var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"pl-2",attrs:{"xs12":""}},[_c('v-flex',{staticClass:"grey--text",attrs:{"xs3":""}},[_vm._v(_vm._s(_vm.label))]),_c('v-flex',{staticClass:"subtitle-1"},[_vm._v("\n        "+_vm._s(_vm.valeur)+"\n    ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }